import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from '../_services/api.service';
import { ChangelogEntry } from '../_models/ChangelogEntry';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-changelog',
    templateUrl: './changelog.component.html',
    styleUrls: ['./changelog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangelogComponent implements OnInit {

  public releases: ChangelogEntry[] = [];
  public pagedReleases: ChangelogEntry[] = [];
  public pageTitle = 'Changelog';

  // Pagination controls
  page = 1;
  pageSize = 5;
  collectionSize = 0;

  constructor(private apiService: ApiService, private viewportScroller: ViewportScroller) { }

  ngOnInit(): void {
    this.loadChangelog();
  }

  loadChangelog(): void {
    this.apiService.getChangelog().subscribe({
      next: (data) => {
        this.releases = data;
        this.collectionSize = data.length;
        this.refreshReleases();
        console.log('Changelog data loaded:', this.releases);
      },
      error: (err) => {
        console.error('Failed to load changelog:', err);
      }
    });
  }
  refreshReleases(): void {
    this.pagedReleases = this.releases
      .map((release, i) => ({ id: i + 1, ...release }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
      this.viewportScroller.scrollToAnchor('change-log');
  }
}
